export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/binder.worker.a109c383.worker.js");
}
